import request from "../utils/request"

export function getNews(){
    return request({
        url:"/web/post/1",
        method:"get"
    })
}

export function getNewsDetails(id){
    return request({
        url:`/web/postId/${id}`,
        method:"get"
    })
}
